import api from '../../common/api';
import url from '../../common/url';

export default {
    namespaced: true,
    state: {
        cache: {},
        key: null,
        catches: [],
        filter: {
            records: false,
            species: null,
            catcher: null,
            region: null,
        },
        isLoading: false,
    },
    mutations: {
        setFilter(state, filter) {
            state.filter = filter;
            state.key = null;
            state.catches = [];
            if (!filter || !filter.region) return;
            const queries = [];
            queries.push(`region=${filter.region.id}`);
            if (filter.catcher) {
                queries.push(`catcher=${filter.catcher.id}`);
            }
            if (filter.species) {
                queries.push(`species=${filter.species.id}`);
            }
            const uri = filter.records ? url.getRecordsByQuery(queries) : url.getCatchesByQuery(queries);
            if (!state.cache[uri]) state.cache[uri] = { items: [], nextUri: uri };
            state.key = uri;
            state.catches = state.cache[uri].items;
            window.scrollTo(0, 0);
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        addPage(state, page) {
            if (!state.cache[page.key]) state.cache[page.key] = { items: [], nextUri: null };
            state.cache[page.key].items = [...state.cache[page.key].items, ...page.items];
            state.cache[page.key].nextUri = page.nextUri;
        },
        setCatches(state) {
            state.catches = state.cache[state.key].items;
        },
        clearCache(state) {
            state.cache = {};
            state.key = null;
            state.catches = [];
        },
    },
    actions: {
        loadCatchesFromFilter(context, filter) {
            if (!filter || !filter.region) return;
            context.commit('setFilter', filter);
            if (!context.state.key) return;
            if (context.state.cache[context.state.key].items.length > 0) return;
            context.dispatch('loadCatchesFromKey', context.state.key);
        },
        async loadCatchesFromKey(context, key) {
            if (!key || !context.state.cache[key] || !context.state.cache[key].nextUri) return;
            context.commit('setIsLoading', true);
            const page = await api.get(context.state.cache[key].nextUri);
            page.key = key;
            context.commit('setIsLoading', false);
            if (page.error) return;
            context.commit('addPage', page);
            context.commit('setCatches');
        },
    },
};
